/**
 * BuildingSizeIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BuildingSizeIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M18.714 2.25c.966 0 1.75.784 1.75 1.75v5.267l1.024.878a.75.75 0 0 1-.976 1.14l-7.7-6.6a1.25 1.25 0 0 0-1.625 0l-6.15 5.272V19c0 .69.558 1.25 1.25 1.25H11a.75.75 0 0 1 0 1.5H6.286A2.75 2.75 0 0 1 3.536 19v-7.758l-.048.042a.75.75 0 0 1-.976-1.14l7.698-6.597a2.75 2.75 0 0 1 3.58 0l1.317 1.128V4c0-.966.784-1.75 1.75-1.75zm-1.857 1.5a.25.25 0 0 0-.25.25v1.96l2.357 2.02V4a.25.25 0 0 0-.25-.25z"
      clipRule="evenodd"
    />
    <path d="M17.5 13.25a.75.75 0 0 1 0 1.5h-1.69l4.44 4.44V17.5a.75.75 0 0 1 1.5 0V21a.8.8 0 0 1-.058.286q-.019.044-.044.083a.8.8 0 0 1-.118.161.8.8 0 0 1-.244.162q-.048.02-.099.03-.019.008-.039.012l-.017.003a1 1 0 0 1-.131.013h-3.5a.75.75 0 0 1 0-1.5h1.69l-4.44-4.44v1.69a.75.75 0 0 1-1.5 0V14a.75.75 0 0 1 .75-.75z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BuildingSizeIcon = makeIcon('BuildingSizeIcon', BuildingSizeIconSvg)
